import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    setPlanes,
    fetchGrupo,
    setDataGrupo,
    setDataGrupoCopy,
    fetchGrupoPlanesById,
    setPlanesDesdeBusqueda,
    updateListGrupoPlanes,
} from '../../actions/planesActions';
import { putGrupoPlanes, deleteGrupoPlanesById } from '../../api/axios';
import ModalItem from '../General/Modal';
import GoBackArrow from '../General/GoBackArrow';
import BigSpinner from '../General/BigSpinner';
import { toast } from 'react-toastify';
import { withNavigation } from '../General/withNavigation';

// Wrapper para usar hooks en class component
function PlanesEditWrapper(props) {
  const navigate = useNavigate();
  return <PlanesEdit {...props} navigate={navigate} />;
}

class PlanesEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comision: 0,
            request: null,
            descripcion: "",
            cambioInputChange: false,
            comisionPredeterminada: ""
        };
        this.descripcionInputRef = React.createRef();
    };

    componentDidMount() {
        this.props.fetchGrupoPlanesById({
            Page: 1,
            PageSize: 500,
            idGrupoPlan: this.props.idGrupo
        });
        this.props.fetchGrupo({ idGrupoPlan: this.props.idGrupo });
        this.props.setPlanes(this.props.planes);

        if (this.descripcionInputRef.current) {
            this.descripcionInputRef.current.focus();
        }
    }

    myChangeHandler = (e) => {
        var numbersOnly = /^[0-9.]+$/;
        let valor = e.target.value;

        if (e.target.name === "comision") {

            let esNumero = valor.match(numbersOnly);
            if (esNumero === null) {
                this.setState({ cambioInputChange: true, comisionPredeterminada: "" });
                this.props.setDataGrupoCopy({ ...this.props.dataGrupo, [e.target.name]: "" })
                return;
            }
            if (e.target.value > 100) {
                this.setState({ cambioInputChange: true, comisionPredeterminada: 100 });
                this.props.setDataGrupoCopy({ ...this.props.dataGrupo, [e.target.name]: 100 })
            } else {
                this.setState({ cambioInputChange: true, comisionPredeterminada: valor });
                this.props.setDataGrupoCopy({ ...this.props.dataGrupo, [e.target.name]: e.target.value })
            }
        } else {
            this.props.setDataGrupoCopy({ ...this.props.dataGrupo, [e.target.name]: e.target.value })
        }
    }

    /*refactor método onSubmit*/
    onSubmit = async (event) => {
        event.preventDefault();

        const { descripcion, comision } = this.props.dataGrupo;

        // Validación de campos obligatorios
        if (!descripcion || !comision) {
            if (!descripcion) toast.error("Debe agregar una descripción");
            if (!comision) toast.error("Debe agregar una comisión");
            return;
        }

        // Obtención de IDs de planes
        const obtenerIdPlanes = () => {
            if (this.props.planDesdeBusqueda.length > 0) {
                return this.props.planDesdeBusqueda.map(plan => plan.id);
            }
            return this.props.planes.elementos.map(plan => plan.idPlan);
        };

        const idPlanes = obtenerIdPlanes();

        // Validación de existencia de planes
        if (idPlanes.length === 0) {
            toast.error("Debe cargar un plan");
            return;
        }

        // Creación del payload
        const data = {
            idGrupoPlan: this.props.idGrupo,
            descripcion,
            comision: parseFloat(comision),
            listaIdsPlanes: idPlanes,
        };

        try {
            let grupoPlanes = putGrupoPlanes(data);

            grupoPlanes.then(res => {
                // Actualización de la lista
                this.props.updateListGrupoPlanes(this.props.grupoPlanes, data)
                    .then(() => {
                        toast.success("Grupo de planes guardado");
                        this.return();
                    })
                    .catch(err => {
                        console.error("Error al actualizar la lista de Grupo Planes:", err);
                        toast.error("No pudo modificarse");
                    });
            });
        }
        catch (err) {
            if (err.response?.data?.errores)
                err.response.data.errores.forEach(error => toast.error(error));
            else
                toast.error("No pudo modificarse");
        };
    };

    onDelete = () => {
        const req = deleteGrupoPlanesById(this.props.idGrupo);
        req.then(res => {
            toast.success("Grupo de plan borrado");
            this.return();
        }).catch(err => {
            toast.error("No se pudo realizar esta tarea");
        });
    }

    borrarFila = (nroPlan) => {
        let jsonPlanDesdeBusqueda = JSON.stringify(this.props.planDesdeBusqueda);
        if (jsonPlanDesdeBusqueda !== "[]") {
            let index = this.props.planDesdeBusqueda.findIndex(x => x.numero === nroPlan);
            this.props.planDesdeBusqueda.splice(index, 1);
            this.props.setPlanesDesdeBusqueda(this.props.planDesdeBusqueda);
            this.forceUpdate();
        }
    }

    borrarFilaCargadaInicialmente = (nroPlan) => {
        let index = this.props.planes.elementos.findIndex(x => x.numeroPlan === nroPlan);
        this.props.planes.elementos.splice(index, 1);
        this.props.setPlanes(this.props.planes.elementos);
        this.forceUpdate();
    }

    filaPlanes = () => {
        let jsonPlanDesdeBusqueda = JSON.stringify(this.props.planDesdeBusqueda);
        if (jsonPlanDesdeBusqueda !== "[]") {
            var rows = [];
            let htmlData;
            this.props.planDesdeBusqueda.map((item, index) => {
                htmlData =
                    <div className="list-group" key={index}>
                        <a>
                            <div className="list-group-item hover-background-color">
                                <div className="row justify-content-between align-items-center">

                                    <div className="col-2 col-md-1">
                                        <h6 className="box-title font-weight-bold text-center">{item.numero}</h6>
                                    </div>
                                    <div className="col-6 col-md-6 text-break">
                                        <small className="font-14 applyFont">{item.descripcion}</small>
                                    </div>
                                    <div className="col-2 col-md-1 d-flex justify-content-end align-items-center">
                                        <i className="fas fa-trash-alt"
                                            onClick={() => this.borrarFila(item.numero)} />
                                    </div>

                                </div>
                            </div>
                        </a>
                    </div>
                rows.push(htmlData);

            });
            return rows;
        } else {
            var rows = [];
            let htmlData;
            let request = JSON.stringify(this.props.planes);
            if (request != "{}") {
                if (this.props.planes.elementos != undefined) {
                    this.props.planes.elementos.map((item, index) => {
                        htmlData =
                            <div className="list-group" key={index}>
                                <a>
                                    <div className="list-group-item hover-background-color">
                                        <div className="row justify-content-between align-items-center">

                                            <div className="col-2 col-md-1">
                                                <h6 className="box-title font-weight-bold text-center">{item.numeroPlan}</h6>
                                            </div>
                                            <div className="col-6 col-md-6 text-break">
                                                <small className="font-14 applyFont">{item.descripcion}</small>
                                            </div>
                                            <div className="col-2 col-md-1 d-flex justify-content-end align-items-center">
                                                <i className="fas fa-trash-alt"
                                                    onClick={() => this.borrarFilaCargadaInicialmente(item.numeroPlan)} />
                                            </div>

                                        </div>
                                    </div>
                                </a>
                            </div>
                        rows.push(htmlData);
                    });
                }
            }
            return rows;
        }
    }

    return = () => {
        this.props.setPlanes([]);
        const previousPath = this.props.location?.state?.from
        if (previousPath != undefined) {
            if (previousPath.includes('Tipo/Publicaciones/Editar/')) {
                // Viene de Planes
                this.props.navigate(previousPath);
            }
        }
        else {
            // Viene de Tipo Publicacion/Grupo de Planes
            this.props.navigate("/Planes");
        }
    }

    render() {
        let comision;
        if (this.state.cambioInputChange == false) {
            comision = this.props.dataGrupo.comision != undefined ? this.props.dataGrupo.comision : "";
        } else {
            comision = this.state.comisionPredeterminada;
        }

        return (

            <div className="container card">
                <div className="row justify-content-between align-items-center card-body p-4">

                    <div className="col-10 col-md-5 mb-4">
                        <GoBackArrow />
                        <h4 className="card-title d-block d-sm-inline">Editar Grupo Planes</h4>
                    </div>

                    <div className="col-12 col-md-auto button-group text-center">
                        <Link to="/Planes/Busqueda">
                            <button
                                type="button"
                                className="btn btn-sm btn-green"
                            >
                                <i className="fa fa-plus-circle" /> Agregar Planes
                            </button>
                        </Link>
                    </div>

                    <form className="col-12 form-horizontal form-material" onSubmit={this.onSubmit}>

                        <div className="form-group">
                            <div className="row justify-content-evenly">

                                <div className="col-12 col-md-7 mb-3 mb-md-0">
                                    <label className="label-oscura">Descripción</label>
                                    <input
                                        name="descripcion"
                                        type="text"
                                        value={this.props.dataGrupo.descripcion}
                                        onChange={this.myChangeHandler}
                                        id="firstName"
                                        className="form-control"
                                        ref={this.descripcionInputRef}
                                    />
                                </div>

                                <div className="col-12 col-md-5">
                                    <div className="d-flex align-items-center">
                                        <small className="font-14 applyFont">
                                            <i className="fas fa-percent" />
                                        </small>
                                        <label className="label-oscura mx-2">Comisión</label>
                                    </div>
                                    <input
                                        name="comision"
                                        value={comision}
                                        onChange={this.myChangeHandler}
                                        type="text"
                                        className="form-control"
                                        maxLength="5"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-10 col-md-5">
                            <label className="label-oscura">Planes</label>
                        </div>
                        {this.props.isLoading ? (
                            <div className="d-flex justify-content-center my-3">
                                <BigSpinner />
                            </div>
                        ) : (
                            this.filaPlanes()
                        )}

                        <div className="row align-items-center justify-content-center mb-3 text-center mt-3">

                            <button
                                type="submit"
                                className="btn btn-sm background-rojo-megatone waves-light col-auto mx-2"
                                disabled={this.props.isLoading}
                            >
                                Guardar
                            </button>

                            <ModalItem
                                text="¿Desea eliminar el grupo de plan?"
                                onDelete={this.onDelete}
                                centered
                                show={this.state.showModal}
                                btnText="Eliminar"
                                btnStyle="btn btn-sm btn-grey col-auto mx-2"
                            />

                            <button
                                onClick={this.return}
                                className="btn btn-sm btn-light waves-effect waves-light col-auto mx-2"
                            >
                                Cancelar
                            </button>

                        </div>
                    </form>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    isLoading: state.planes.loadingPlanes,
    idGrupo: state.planes.id,
    planes: state.planes.grupoPorId,
    planDesdeBusqueda: state.planes.planesDesdeBusqueda,
    dataGrupo: JSON.stringify(state.planes.dataGrupoCopy) !== "{}"
        ? state.planes.dataGrupoCopy
        : state.planes.dataGrupo,
    grupoPlanes: state.planes.grupoPlanes,
});

export default withNavigation(connect(mapStateToProps, {
    setPlanes,
    fetchGrupo,
    setDataGrupo,
    setDataGrupoCopy,
    fetchGrupoPlanesById,
    setPlanesDesdeBusqueda,
    updateListGrupoPlanes,
})(PlanesEditWrapper));